var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU12 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 348.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-3861.00, 0.00)",
    id: "U12_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3871.21,222.03 C3872.97,217.50 3879.66,204.33 3883.99,196.90 C3888.09,190.19 3897.39,176.28 3902.58,169.08 C3913.33,154.86 3935.60,127.46 3943.12,119.06 C3947.72,113.94 3963.60,99.73 3970.26,94.75 C3976.95,89.78 3989.33,82.71 3995.86,80.20 C4002.40,77.72 4015.81,74.91 4022.53,74.84 C4029.02,74.80 4042.45,76.50 4049.41,78.24 C4056.77,80.11 4070.97,85.66 4078.76,89.74 C4086.39,93.77 4099.05,101.92 4107.26,108.28 C4118.61,117.46 4143.56,140.48 4155.31,152.64 C4162.29,160.25 4172.46,172.40 4176.46,177.82 C4181.03,184.04 4189.46,197.43 4192.34,203.43 C4196.20,211.55 4201.51,227.38 4202.98,235.20 C4204.42,243.03 4204.93,258.42 4203.91,265.85 C4202.86,273.29 4198.26,287.58 4194.65,294.62 C4191.74,300.23 4182.39,312.51 4177.06,318.04 C4171.72,323.58 4159.37,334.04 4151.85,339.41 C4138.41,349.08 4082.79,389.42 4073.54,396.50 C4070.15,399.14 4065.25,402.09 4062.08,403.35 C4058.92,404.58 4052.02,406.11 4048.27,406.41 C4041.61,406.91 4028.10,404.65 4021.21,402.60 C4014.31,400.52 4000.66,394.97 3991.11,390.38 C3983.26,386.50 3968.09,378.58 3960.77,374.55 C3948.98,367.80 3943.79,364.47 3932.68,356.52 C3926.00,351.52 3913.23,341.30 3907.15,336.09 C3901.10,330.75 3890.80,320.00 3886.38,314.41 C3881.28,307.93 3874.99,297.46 3871.86,290.00 C3869.10,283.37 3865.22,268.89 3864.57,262.61 C3864.22,259.05 3864.32,251.45 3864.76,247.49 C3865.70,239.56 3869.72,225.93 3871.21,222.03 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU12, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-12.9203c157.svg";
export { ForwardRef as ReactComponent };